import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { DurationToRelativeFormatPipe } from './duration.pipe';

@NgModule({
   imports: [CommonModule],
   declarations: [DurationToRelativeFormatPipe],
   exports: [DurationToRelativeFormatPipe],
})
export class DurationToRelativeFormatPipeModule {}
